import { useRouterState } from '@tanstack/react-router';
import { useIsomorphicLayoutEffect } from './use-isomorphic-layout-effect';

type RouterLocation = ReturnType<typeof useRouterState>['location'];

const scrollDocumentToTop = () => {
	window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
	document.documentElement.scrollTop = 0;
	document.body.scrollTop = 0;
};

export const useScrollRestoration = (location?: RouterLocation) => {
	const stateLocation = useRouterState().location;
	const resolvedLocation = location ?? stateLocation;

	useIsomorphicLayoutEffect(() => {
		if (typeof window === 'undefined') return;

		const hash = resolvedLocation.hash?.replace(/^#/, '').trim();
		if (hash) {
			// Delay until after paint so anchors present in DOM are targeted reliably.
			requestAnimationFrame(() => {
				const target = document.getElementById(hash);
				if (target) {
					target.scrollIntoView({ behavior: 'auto', block: 'start' });
					return;
				}
				scrollDocumentToTop();
			});
			return;
		}

		scrollDocumentToTop();
	}, [resolvedLocation.pathname, resolvedLocation.searchStr, resolvedLocation.hash]);
};
